// extracted by mini-css-extract-plugin
export default {"footer":"ProjectFooter_footer__w-Uuk","footerOne":"ProjectFooter_footerOne__88-9T","text":"ProjectFooter_text__iC0-G"};